export default function HeaderNav() {
	jQuery(document).ready(function ($) {
		// changing the nav to white on scroll can be found in 'header-on-scroll.js'

		const searchSvg = $('.nav__searchsvg');
		const navLevel1 = $('.nav__level1');
		const hamburger = $('.header__hamburger');
		const header = $('.header');
		const nav = $('.nav');
		const closeMobile = $('.header__closeMobile');
		const navLevel1NoParent = $('.nav__title--noParent');
		const searchModal = $('.searchModal');
		const searchModalClose = $('.searchModal__close');
		const windowTablet = 1100;
		const searchInput = document.getElementById('site-search');
		const searchIn = $('#site-search');
		const searchSubmit = $('.searchModal__submit');

		const navSliderContainer = $('.navSlider__container');
		const navSliderSettings = {
			dots: true,
			infinite: true,
			autoplay: true,
			speed: 500,
			pauseOnHover: true,
			touchMove: true,
			fade: true,
			arrows: false,
			cssEase: 'linear',
			accessibility: true,
			responsive: [
				{
					breakpoint: 550,
					settings: {
						dots: false,
						arrows: false,
						infinite: true,
						centerMode: true,
						centerPadding: '25px',
						swipeToSlide: true,
						swipe: true,
						speed: 300,
						slidesToShow: 1,
					},
				},
			],
		};

		navSliderContainer.slick(navSliderSettings);

		$(window).on('resize', function () {
			if ($(window).width() < 550) {
				return;
			}
			if (!navSliderContainer.hasClass('slick-initialized')) {
				return navSliderContainer.slick(navSliderSettings);
			}
		});

		function openSearch() {
			searchModal.toggleClass('searchModal--open');
			searchInput.focus();
		}

		function closeSearch() {
			searchModal.toggleClass('searchModal--open');
		}

		function openMobileNav() {
			$('body').addClass('bodyMobileNav');
			header.addClass('headerOpen');
			nav.addClass('nav__open');
			if ($('.alerts').length > 0) {
				$('.alerts').css('display', 'none');
			}
		}

		function closeMobileNav() {
			$('body').removeClass('bodyMobileNav');
			header.removeClass('headerOpen');
			nav.removeClass('nav__open');
			if ($('.alerts').length > 0) {
				$('.alerts').css('display', 'block');
			}
		}

		function clickTabletLevelTwo(e) {
			if ($(window).width() < windowTablet) {
				if (e.target.classList.contains('nav__level1--open')) {
					navLevel1.removeClass('nav__level1--open');
				} else {
					navLevel1.removeClass('nav__level1--open');
					e.target.classList.add('nav__level1--open');
					navSliderContainer.slick('setPosition');
				}
			}
		}

		function mouseEnterDeskNav(e) {
			let eTarget = $(e.target);
			if ($(window).width() > windowTablet) {
				navLevel1.removeClass('nav__level1--open');
				eTarget.addClass('nav__level1--open');
				navSliderContainer.slick('setPosition');
			}
		}

		function mouseLeaveDeskNav() {
			if ($(window).width() > windowTablet) {
				navLevel1.removeClass('nav__level1--open');
			}
		}

		function menuIndicatorPosition() {
			navLevel1.each(function () {
				const navIndicator = $(this).children('.nav__indicator');
				const halfWidth = `${$(this).innerWidth() / 2}`;
				const positionLeft = halfWidth - 36.5;
				navIndicator.css('left', `${positionLeft}px`);
			});
		}

		function getInputValue(e) {
			let input;

			input = document.getElementById('site-search');

			if (input.value.length <= 2) {
				$('.searchModal__searchResults').empty();
				$('.searchModal__searchResults').removeClass(
					'searchModal__searchResults--open'
				);
				return;
			}
			$.get(
				'/api/v1/search',
				{
					phrase: input.value,
				},
				function (res) {
					if (res.data === null || res.data.length === 0) {
						$('.searchModal__searchResults').empty();
						$('.searchModal__searchResults').removeClass(
							'nav__searchResults--open'
						);
						return;
					}

					let filteredArray = res.data.filter((obj) => obj.url !== null);
					console.log(filteredArray);
					input = document.getElementById('site-search');
					let results;
					if ($(window).width() > 768) {
						results = document.getElementById('searchResults');
					} else {
						results = document.getElementById('searchResultsMobile');
					}

					$('.searchModal__searchResults').addClass('nav__searchResults--open');

					results.innerHTML = filteredArray
						.map(
							(el) => `<li> <a href="${el.url}"><p>${el.title}</p></a> </li>`
						)
						.join('');
				}
			);
		}

		function searchSubmitFunction() {
			let input = document.getElementById('site-search');
			window.location.href =
				window.location.origin + `/search?q=${input.value}`;
		}

		function keySubmit(e) {
			if (e.key === 'Enter') {
				searchSubmitFunction();
			}
		}

		/* event listener */
		searchInput.addEventListener('input', getInputValue);

		menuIndicatorPosition();
		searchIn.on('keyup', keySubmit);
		$(window).on('resize', menuIndicatorPosition);
		searchSvg.on('click', openSearch);
		searchModalClose.on('click', closeSearch);
		searchSubmit.on('click', searchSubmitFunction);
		hamburger.on('click', openMobileNav);
		closeMobile.on('click', closeMobileNav);
		navLevel1.on('click', clickTabletLevelTwo);
		navLevel1.on('mouseenter focus', mouseEnterDeskNav);
		navLevel1NoParent.on('mouseenter focus', mouseLeaveDeskNav);
		nav.on('mouseleave', mouseLeaveDeskNav);
	});
}
